module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAZUlEQVR42u3VsQ2AMAxE0RRMAEySwTwFYzEDygDZBZwiFECVJhf0v3T9kxuHQEQ0botvVsGsvuQ7FFBTgZjZWSaBqhhQoEB1aHug9p6Y+HGlCAYMmMZvn1UwrwspYG6UEoaI6LddleGS2KTb9ZoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/pdf-viewer/arrow_right.png
// module id = 467
// module chunks = 438